import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { useState, useEffect } from "react";
// @mui
import { Box } from "@mui/material";
import useAuth from "src/hooks/useAuth";
import axios from "src/utils/axios";

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const auth = useAuth();
  const user = auth?.user;
  const cachedLogo = !user?.companyId ? null : localStorage.getItem(`company_logo_${user.companyId}`);
  const [companyLogo, setCompanyLogo] = useState(cachedLogo);

  const isSuperAdmin = user?.role === "SUPER_ADMIN";

  useEffect(() => {
    if (!isSuperAdmin && user?.companyId) {
      axios.get(`/company/${user.companyId}`)
        .then((res) => {
          const logo = res?.data?.data?.logoUrl || res?.data?.logoUrl;
          if (logo) {
            setCompanyLogo(logo);
            localStorage.setItem(`company_logo_${user.companyId}`, logo);
          }
        })
        .catch(() => {});
    }
  }, [user?.companyId, isSuperAdmin]);

  const logoSrc = isSuperAdmin || !companyLogo
    ? "/logo/smart-supervisor-logo.png"
    : companyLogo;

  const logo = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'auto',
        height: 80,
        ...sx
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt={isSuperAdmin ? "Smart Supervisor" : user?.company?.name || "Company"}
        sx={{ height: 60, width: 'auto', objectFit: 'contain' }}
      />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/" style={{ textDecoration: 'none' }}>{logo}</RouterLink>;
}